import styled from "@emotion/styled";
import { Col, Form, Input, Popconfirm } from "antd";
import TextArea from "antd/es/input/TextArea";
import { InfoCircleOutlined } from "@ant-design/icons";
import React from "react";

const ProductRecommendForm = () => {
  return (
    <FormWrapper>
      <Form.Item
        label="ลิงค์วีดีโอ  "
        name="video_url"
      //rules={[{ required: is_active, message: "กรุณากรอกลิงค์วีดีโอ" }]}
      >
        <Input
          placeholder="ลิงค์วีดีโอ"
          // showCount
          // maxLength={120}
          size="small"
        />
      </Form.Item>
      <Form.Item
        label="ข้อกำหนดแพ็คเกจ"
        name="recomended_retail"
        // rules={[{ required: true, message: "กรุณากรอกชื่อสินค้า" }]}
        tooltip={{
          title: <TooltipContent />,
          icon: <InfoCircleOutlined />,
          color: "#ffffff",
        }}
      >
        <TextArea
          placeholder="ข้อกำหนดแพ็คเกจ"
          showCount
          maxLength={5000}
          rows={4}
        />
      </Form.Item>
    </FormWrapper>
  );
};

const TooltipContent = () => {
  return (
    <div style={{ width: "100%" }}>
      <h6 style={{ color: "black" }}>หมายเหตุ</h6>
      <p style={{ color: "black" }}>
        ข้อกำหนดแพ็คเกจ คือคำอธิบายหรือข้อควรระวัง สำหรับพยาบาลหรือตัวแทน ที่จำเป็นต้องทราบก่อนการขายแพ็คเกจให้กับผู้รับบริการ
      </p>
    </div>
  );
};

export default ProductRecommendForm;

const FormWrapper = styled.div`
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  padding: 20px 20px 2px 20px;
  margin-bottom: 10px;
  border-radius: 8px;
`;
